"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const FormGroup_1 = __importDefault(require("@mui/material/FormGroup"));
const FormControlLabel_1 = __importDefault(require("@mui/material/FormControlLabel"));
const Checkbox_1 = __importDefault(require("../Checkbox"));
const iconProps = { size: 16 };
const StyledFormGroup = (0, styled_components_1.default)(FormGroup_1.default) `
  .MuiFormControlLabel-root {
    margin-bottom: 12px;
  }

  .MuiFormControlLabel-label {
    color: ${({ theme }) => theme.palette.text.primary};
    ${({ theme }) => theme.typography.variants.primary.main};
  }
`;
const CheckboxGroup = ({ options, onChange, value, ...rest }) => {
    return ((0, jsx_runtime_1.jsx)(StyledFormGroup, { ...rest, children: options.map((option) => ((0, jsx_runtime_1.jsx)(FormControlLabel_1.default, { ...option, control: ((0, jsx_runtime_1.jsx)(Checkbox_1.default, { checked: value?.includes(option.value), checkedIconProps: iconProps, name: option.label, onChange: onChange, uncheckedIconProps: iconProps })), label: option.label }, `${option.label}-${option.value}`))) }));
};
exports.default = CheckboxGroup;
//# sourceMappingURL=index.js.map